import 'cross-fetch/polyfill';
import EventEmitter from './event-emitter/event-emitter';

export { EventEmitter };

export * from './typings';
export * from './shell/shell';
export * from './component/component';
export * from './loader/lazy-loader';
export * from './loader/ssr-loader';
